import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches candidates list from the API
 *
 * @param {import('../types/Candidates.parameters').IGetCandidatesPayload} payload - Request payload
 * @returns {Promise<import('../types/Candidates.api').IGetCandidatesApiResponse>} Candidates API response
 */
export const getCandidates = async ({ postingId, page, pageSize, status, name }) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get(
    `/recruitment-service/admin/postings/${postingId}/candidates`,
    {
      headers,
      params: {
        page,
        pageSize,
        status: status || undefined,
        name: name || undefined,
      },
    },
  );
  return response.data;
};
